import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { mediaActions } from '../actions'
import FileNavigationPopup from '../../FileNavigationPopup'
import NotFound from '../../NotFound'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import styles from './styles.module.scss'
import Spinner from 'srcReact/components/common2/Spinner'
import MediaImage from '../../MediaImage'

function PictureList({ type, id, noDatatitle, handleDelete, deleteFileLoading, isStatic, parentElementId }) {
  const [showImagePopup, setShowImagePopup] = useState(false)
  const [currentFile, setCurrenFile] = useState(null)
  const [currentFileIndex, setCurrenFileIndex] = useState(0)
  const [decryptedPictures, setDecryptedPictures] = useState([])
  const [decryptInProcess, setDecryptInProcess] = useState(false)
  const dispatch = useDispatch()
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })

  const {
    login: { user: loggedInUser },
    common: { isMobile, isNative },
    media: { pictures, entityId }
  } = useSelector((state) => state)

  const openImageModal = (picture, pictureIndex) => {
    setShowImagePopup(true)
    setCurrenFile(picture)
    setCurrenFileIndex(pictureIndex)
  }

  const closeImageModal = () => {
    setShowImagePopup(false)
    setCurrenFile(null)
    setCurrenFileIndex(-1)
  }

  useEffect(() => {
    if (!isStatic) {
      dispatch(mediaActions.getPictures(type, id, pagination))
    }
  }, [pagination])

  const lastPictureRef = useInfinitScroll(
    pictures.loading,
    pictures.stats && pictures.stats.remaining,
    pictures.stats && pictures.stats.next_offset,
    setPagination,
    [pictures.loading]
  )

  return (
    <React.Fragment>
      {isStatic || (!pictures.loading && pictures.stats && pictures.stats.total === 0) ? (
        <NotFound title={noDatatitle} className={styles.notFoundWrapper} />
      ) : (
        <div className={styles.photoList}>
          {pictures?.list &&
            pictures.list.map((picture, index) => {
              const isLast = pictures.list.length === index + 1
              return (
                <div ref={isLast ? lastPictureRef : null}>
                  <MediaImage
                    key={`${picture.id}_${index}`}
                    file={picture}
                    files={pictures.list}
                    showImageModal={openImageModal}
                    index={index}
                    className={styles.image}
                    parentElementId={parentElementId}
                    size={isMobile || isNative ? 'large' : 'xlarge'}
                  />
                </div>
              )
            })}
        </div>
      )}
      {!isStatic && (Object.keys(pictures.stats).length === 0 || decryptInProcess || pictures.loading) && <Spinner />}
      {showImagePopup && currentFile && (
        <FileNavigationPopup
          isOpen={showImagePopup}
          file={currentFile}
          fileIndex={currentFileIndex}
          files={pictures.list}
          closeModal={closeImageModal}
          deleteFile={handleDelete}
          loggedInUserId={loggedInUser.id}
          showShareButton={false}
          loadingFileDeletion={deleteFileLoading}
          enableDeleteFile={true}
          showPagination={false}
          isImage={true}
        />
      )}
    </React.Fragment>
  )
}

export default PictureList
